import { usePage } from "PFApp/use_page";
import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  checkFiltersAreClear,
  getValueFilters,
  handleRequestFiltersChange
} from "../use_filtered_collection";
import { useFilters } from "./hooks/use_filters";
import { useFlattenedAvailabilityFilters } from "./utils/use_flattened_availability_filters";

const useInsightsPage = (initPage) => {
  const { page, mergePage, setPage, resetPage } = usePage(`insights`, initPage);
  const { data: currentProfile } = useCurrentProfile();
  const { customTypes } = useCustomTypes();

  const history = useHistory();
  const { state } = useLocation();
  const { formatISODate } = useDateFormatter();

  const defaultFilters = {
    roles: {
      availability: {
        start: formatISODate(moment().subtract(1, "week")),
        end: formatISODate()
      }
    },
    skills: {},
    platform: {
      availability: {
        start: formatISODate(moment().subtract(3, "months")),
        end: formatISODate()
      }
    }
  };

  const [tab, setTab] = useState(initPage.tab || "roles");
  const [selectedFilters, setSelectedFilters] = useState(state ? state.selectedFilters : defaultFilters[tab]);
  const [modalData, setModalData] = useState(null);

  const flattenedFilters = useFlattenedAvailabilityFilters(selectedFilters);

  const changeTab = (newTab) => {
    history.push(`/insights/${newTab}`);
    handleFiltersReset(newTab);
    setTab(newTab);
  };

  const insightsMeta = useFilters({
    customTypes: customTypes,
    selectedFilters: selectedFilters,
    currentProfile: currentProfile,
    tab: tab
  });

  useEffect(() => {
    mergePage({ insightsMeta });
  }, [insightsMeta]);

  const handleFilterChange = (filter, value) => {
    setSelectedFilters(() => {
      const valueFilters = getValueFilters(insightsMeta.filters);
      const newFilters = handleRequestFiltersChange(valueFilters, filter, value);
      return newFilters;
    });
  };

  useEffect(() => {
    mergePage({ selectedFilters: flattenedFilters });
  }, [selectedFilters]);

  const handleFiltersReset = (tab = "roles") => setSelectedFilters(defaultFilters[tab]);

  const noFiltersSelected = checkFiltersAreClear(insightsMeta.filters);

  useEffect(() => mergePage({ modalData }), [modalData]);

  useEffect(() => {
    setPage({
      ...initPage,
      tab,
      changeTab,
      initialized: true,
      insightsMeta,
      handleFilterChange,
      handleFiltersReset,
      noFiltersSelected,
      selectedFilters: flattenedFilters,
      setModalData
    });
    return resetPage;
  }, [selectedFilters]);

  return page;
};

export default useInsightsPage;
